var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKitchen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "kitchen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2167.062,
    height: 797.664,
    viewBox: "0 0 2167.062 797.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-kitchen",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c7283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#627c8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-kitchen-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1c8bd",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c1c8bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c8bd",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M1084.29,383.186c-11.451,2.39-24,3.491-47.561,3.491s-36.33-1.1-48.1-3.491C982.874,382.018,978,378.428,978,372.559V316.47h116.917v56.089C1094.916,378.428,1090.035,381.987,1084.29,383.186Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M944.248,366.325c-9.226,1.926-19.338,2.813-38.319,2.813s-29.271-.887-38.756-2.813c-4.634-.94-8.562-3.833-8.562-8.561V300.572h94.2v57.192C952.809,362.492,948.876,365.359,944.248,366.325Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M947.419,385.5c-12.012,2.507-25.178,3.662-49.892,3.662s-38.111-1.155-50.462-3.662c-6.033-1.224-7.686-6.055-11.147-11.147-2.508-3.688-9.973-14.777-9.973-14.777H968.539s-7.082,10.64-9.972,14.777C955.041,379.4,953.446,384.245,947.419,385.5Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kitchen-2",
    "data-name": "kitchen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1675",
    "data-name": "Group 1675",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1086",
    "data-name": "Rectangle 1086",
    width: 1567.494,
    height: 194.494,
    transform: "translate(299.784 252.941)",
    fill: "url(#linear-gradient-kitchen)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1088",
    "data-name": "Rectangle 1088",
    transform: "translate(263.333 762.225) rotate(-180)",
    fill: "#3a5170",
    stroke: "#324963",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 252.941,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 250.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1089",
    "data-name": "Rectangle 1089",
    transform: "translate(263.333 509.283) rotate(-180)",
    fill: "#3a5170",
    stroke: "#324963",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 509.283,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 507.283,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M17.075,402.034l36.45-43.353V164.187H17.075Z",
    transform: "translate(246.259 88.754)",
    fill: "#425d7a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1603",
    "data-name": "Group 1603",
    transform: "translate(231.423 388.119)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1090",
    "data-name": "Rectangle 1090",
    width: 95.119,
    height: 7.927,
    transform: "translate(7.927 0) rotate(90)",
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1091",
    "data-name": "Rectangle 1091",
    width: 95.119,
    height: 3.954,
    transform: "translate(11.881 0) rotate(90)",
    fill: "#374d69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604",
    transform: "translate(231.423 529.811)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1092",
    "data-name": "Rectangle 1092",
    width: 95.119,
    height: 7.927,
    transform: "translate(7.927) rotate(90)",
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1093",
    "data-name": "Rectangle 1093",
    width: 95.119,
    height: 3.954,
    transform: "translate(11.881 0) rotate(90)",
    fill: "#374d69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606",
    transform: "translate(124.664 240.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M-67.795,203.59-108,199.353l.565-38.16H-66.79Z",
    transform: "translate(121.595 -151.737)",
    fill: "#324963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M-107.17,156.535l40.38,4.658s-2.4,29.887-10.542,43.637l-44.263-5.107C-111.869,185.894-107.17,156.535-107.17,156.535Z",
    transform: "translate(121.595 -151.737)",
    fill: "#4c593d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605",
    transform: "translate(27.215)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_467",
    "data-name": "Ellipse 467",
    cx: 7.426,
    cy: 7.426,
    rx: 7.426,
    ry: 7.426,
    transform: "translate(2.736)",
    fill: "#422c31"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_468",
    "data-name": "Ellipse 468",
    cx: 7.426,
    cy: 7.426,
    rx: 7.426,
    ry: 7.426,
    fill: "#4d3539"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1639",
    "data-name": "Group 1639",
    transform: "translate(299.784 252.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607",
    transform: "translate(1518.51)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1094",
    "data-name": "Rectangle 1094",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1095",
    "data-name": "Rectangle 1095",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1096",
    "data-name": "Rectangle 1096",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1097",
    "data-name": "Rectangle 1097",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1608",
    "data-name": "Group 1608",
    transform: "translate(1469.526)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1098",
    "data-name": "Rectangle 1098",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1099",
    "data-name": "Rectangle 1099",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1100",
    "data-name": "Rectangle 1100",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1101",
    "data-name": "Rectangle 1101",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1609",
    "data-name": "Group 1609",
    transform: "translate(1420.541)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1102",
    "data-name": "Rectangle 1102",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1103",
    "data-name": "Rectangle 1103",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1104",
    "data-name": "Rectangle 1104",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1610",
    "data-name": "Group 1610",
    transform: "translate(1371.557)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1106",
    "data-name": "Rectangle 1106",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1107",
    "data-name": "Rectangle 1107",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1611",
    "data-name": "Group 1611",
    transform: "translate(1322.573)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1110",
    "data-name": "Rectangle 1110",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1111",
    "data-name": "Rectangle 1111",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1112",
    "data-name": "Rectangle 1112",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1113",
    "data-name": "Rectangle 1113",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1612",
    "data-name": "Group 1612",
    transform: "translate(1273.589)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1114",
    "data-name": "Rectangle 1114",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1115",
    "data-name": "Rectangle 1115",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1116",
    "data-name": "Rectangle 1116",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1117",
    "data-name": "Rectangle 1117",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613",
    transform: "translate(1224.605)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1118",
    "data-name": "Rectangle 1118",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1119",
    "data-name": "Rectangle 1119",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1120",
    "data-name": "Rectangle 1120",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1121",
    "data-name": "Rectangle 1121",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1614",
    "data-name": "Group 1614",
    transform: "translate(1175.62)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1122",
    "data-name": "Rectangle 1122",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1123",
    "data-name": "Rectangle 1123",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1124",
    "data-name": "Rectangle 1124",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1125",
    "data-name": "Rectangle 1125",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615",
    transform: "translate(1126.636)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1126",
    "data-name": "Rectangle 1126",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1127",
    "data-name": "Rectangle 1127",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1128",
    "data-name": "Rectangle 1128",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1129",
    "data-name": "Rectangle 1129",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1616",
    "data-name": "Group 1616",
    transform: "translate(1077.652)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1130",
    "data-name": "Rectangle 1130",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1131",
    "data-name": "Rectangle 1131",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1132",
    "data-name": "Rectangle 1132",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1133",
    "data-name": "Rectangle 1133",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1617",
    "data-name": "Group 1617",
    transform: "translate(1028.668)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1134",
    "data-name": "Rectangle 1134",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1135",
    "data-name": "Rectangle 1135",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1136",
    "data-name": "Rectangle 1136",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1137",
    "data-name": "Rectangle 1137",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1618",
    "data-name": "Group 1618",
    transform: "translate(979.684)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1138",
    "data-name": "Rectangle 1138",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1139",
    "data-name": "Rectangle 1139",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1140",
    "data-name": "Rectangle 1140",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1141",
    "data-name": "Rectangle 1141",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1619",
    "data-name": "Group 1619",
    transform: "translate(930.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1142",
    "data-name": "Rectangle 1142",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1143",
    "data-name": "Rectangle 1143",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1144",
    "data-name": "Rectangle 1144",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1145",
    "data-name": "Rectangle 1145",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1620",
    "data-name": "Group 1620",
    transform: "translate(881.715)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1146",
    "data-name": "Rectangle 1146",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1147",
    "data-name": "Rectangle 1147",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1148",
    "data-name": "Rectangle 1148",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1149",
    "data-name": "Rectangle 1149",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1621",
    "data-name": "Group 1621",
    transform: "translate(832.731)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1150",
    "data-name": "Rectangle 1150",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1151",
    "data-name": "Rectangle 1151",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1152",
    "data-name": "Rectangle 1152",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1153",
    "data-name": "Rectangle 1153",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1622",
    "data-name": "Group 1622",
    transform: "translate(783.747)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1154",
    "data-name": "Rectangle 1154",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1155",
    "data-name": "Rectangle 1155",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1156",
    "data-name": "Rectangle 1156",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1157",
    "data-name": "Rectangle 1157",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1623",
    "data-name": "Group 1623",
    transform: "translate(734.763)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1158",
    "data-name": "Rectangle 1158",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1159",
    "data-name": "Rectangle 1159",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1160",
    "data-name": "Rectangle 1160",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1161",
    "data-name": "Rectangle 1161",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1624",
    "data-name": "Group 1624",
    transform: "translate(685.779)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1162",
    "data-name": "Rectangle 1162",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1163",
    "data-name": "Rectangle 1163",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1164",
    "data-name": "Rectangle 1164",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1165",
    "data-name": "Rectangle 1165",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1625",
    "data-name": "Group 1625",
    transform: "translate(636.794)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1166",
    "data-name": "Rectangle 1166",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1167",
    "data-name": "Rectangle 1167",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1168",
    "data-name": "Rectangle 1168",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1169",
    "data-name": "Rectangle 1169",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626",
    transform: "translate(587.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1170",
    "data-name": "Rectangle 1170",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1171",
    "data-name": "Rectangle 1171",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1172",
    "data-name": "Rectangle 1172",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1173",
    "data-name": "Rectangle 1173",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1627",
    "data-name": "Group 1627",
    transform: "translate(538.826)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1174",
    "data-name": "Rectangle 1174",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1175",
    "data-name": "Rectangle 1175",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1176",
    "data-name": "Rectangle 1176",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1177",
    "data-name": "Rectangle 1177",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1628",
    "data-name": "Group 1628",
    transform: "translate(489.842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1178",
    "data-name": "Rectangle 1178",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1179",
    "data-name": "Rectangle 1179",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1180",
    "data-name": "Rectangle 1180",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1181",
    "data-name": "Rectangle 1181",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1629",
    "data-name": "Group 1629",
    transform: "translate(440.858)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1182",
    "data-name": "Rectangle 1182",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1183",
    "data-name": "Rectangle 1183",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1184",
    "data-name": "Rectangle 1184",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1185",
    "data-name": "Rectangle 1185",
    width: 48.984,
    height: 48.623,
    transform: "translate(0)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1630",
    "data-name": "Group 1630",
    transform: "translate(391.873)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1186",
    "data-name": "Rectangle 1186",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1187",
    "data-name": "Rectangle 1187",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1188",
    "data-name": "Rectangle 1188",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1189",
    "data-name": "Rectangle 1189",
    width: 48.984,
    height: 48.623,
    transform: "translate(0)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1631",
    "data-name": "Group 1631",
    transform: "translate(342.889)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1190",
    "data-name": "Rectangle 1190",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1191",
    "data-name": "Rectangle 1191",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1192",
    "data-name": "Rectangle 1192",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1193",
    "data-name": "Rectangle 1193",
    width: 48.984,
    height: 48.623,
    transform: "translate(0)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1632",
    "data-name": "Group 1632",
    transform: "translate(293.905)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1194",
    "data-name": "Rectangle 1194",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1195",
    "data-name": "Rectangle 1195",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1196",
    "data-name": "Rectangle 1196",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1197",
    "data-name": "Rectangle 1197",
    width: 48.984,
    height: 48.623,
    transform: "translate(0)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1633",
    "data-name": "Group 1633",
    transform: "translate(244.921)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1198",
    "data-name": "Rectangle 1198",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1199",
    "data-name": "Rectangle 1199",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1200",
    "data-name": "Rectangle 1200",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1201",
    "data-name": "Rectangle 1201",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1634",
    "data-name": "Group 1634",
    transform: "translate(195.937)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1202",
    "data-name": "Rectangle 1202",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1203",
    "data-name": "Rectangle 1203",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1204",
    "data-name": "Rectangle 1204",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1205",
    "data-name": "Rectangle 1205",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1635",
    "data-name": "Group 1635",
    transform: "translate(146.953)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1206",
    "data-name": "Rectangle 1206",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1207",
    "data-name": "Rectangle 1207",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1208",
    "data-name": "Rectangle 1208",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1209",
    "data-name": "Rectangle 1209",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1636",
    "data-name": "Group 1636",
    transform: "translate(97.968)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1210",
    "data-name": "Rectangle 1210",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1211",
    "data-name": "Rectangle 1211",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1212",
    "data-name": "Rectangle 1212",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1213",
    "data-name": "Rectangle 1213",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1637",
    "data-name": "Group 1637",
    transform: "translate(48.984)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1214",
    "data-name": "Rectangle 1214",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1215",
    "data-name": "Rectangle 1215",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1216",
    "data-name": "Rectangle 1216",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1217",
    "data-name": "Rectangle 1217",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1638",
    "data-name": "Group 1638",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1218",
    "data-name": "Rectangle 1218",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1219",
    "data-name": "Rectangle 1219",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1220",
    "data-name": "Rectangle 1220",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1221",
    "data-name": "Rectangle 1221",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1222",
    "data-name": "Rectangle 1222",
    width: 1640.199,
    height: 18.495,
    transform: "translate(263.529 490.788)",
    fill: "#374d69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M17.271,402.034h1640l-36.254-43.353H53.525Z",
    transform: "translate(246.259 88.754)",
    fill: "#50708e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1223",
    "data-name": "Rectangle 1223",
    width: 2167.062,
    height: 35.439,
    transform: "translate(0 762.225)",
    fill: "#222e44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1224",
    "data-name": "Rectangle 1224",
    width: 263.333,
    height: 252.941,
    transform: "translate(790.196 509.283)",
    fill: "#173f5e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1225",
    "data-name": "Rectangle 1225",
    transform: "translate(1376.866)",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 252.941,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 250.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1226",
    "data-name": "Rectangle 1226",
    transform: "translate(1053.529)",
    fill: "#4d5e82",
    stroke: "#47587a",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323.337,
    height: 197.885,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 321.337,
    height: 195.885,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1227",
    "data-name": "Rectangle 1227",
    transform: "translate(1053.529 197.885)",
    fill: "#4d5e82",
    stroke: "#47587a",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323.337,
    height: 55.056,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 321.337,
    height: 53.056,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1228",
    "data-name": "Rectangle 1228",
    transform: "translate(1640.199)",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 252.941,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 250.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1229",
    "data-name": "Rectangle 1229",
    transform: "translate(790.196)",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 252.941,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 250.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1230",
    "data-name": "Rectangle 1230",
    transform: "translate(526.862)",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 252.941,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 250.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1231",
    "data-name": "Rectangle 1231",
    transform: "translate(263.529)",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 252.941,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 250.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1232",
    "data-name": "Rectangle 1232",
    width: 263.333,
    height: 252.941,
    transform: "translate(1640.199 509.283)",
    fill: "#173f5e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1233",
    "data-name": "Rectangle 1233",
    transform: "translate(1903.728 509.283)",
    fill: "#3a5170",
    stroke: "#324963",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 252.941,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 250.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1234",
    "data-name": "Rectangle 1234",
    transform: "translate(1903.728)",
    fill: "#3a5170",
    stroke: "#324963",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 509.283,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 507.283,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M1657.471,402.034l-36.45-43.353V164.187h36.45Z",
    transform: "translate(246.258 88.754)",
    fill: "#425d7a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1641",
    "data-name": "Group 1641",
    transform: "translate(1376.866 509.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1235",
    "data-name": "Rectangle 1235",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 252.941,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 260.333,
    height: 249.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1640",
    "data-name": "Group 1640",
    transform: "translate(83.182 12.601)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1236",
    "data-name": "Rectangle 1236",
    width: 95.119,
    height: 7.927,
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1237",
    "data-name": "Rectangle 1237",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1642",
    "data-name": "Group 1642",
    transform: "translate(1923.758 388.119)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1238",
    "data-name": "Rectangle 1238",
    width: 95.119,
    height: 7.927,
    transform: "translate(11.881) rotate(90)",
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1239",
    "data-name": "Rectangle 1239",
    width: 95.119,
    height: 3.954,
    transform: "translate(3.954) rotate(90)",
    fill: "#374d69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1643",
    "data-name": "Group 1643",
    transform: "translate(1923.758 529.811)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1240",
    "data-name": "Rectangle 1240",
    width: 95.119,
    height: 7.927,
    transform: "translate(11.881) rotate(90)",
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1241",
    "data-name": "Rectangle 1241",
    width: 95.119,
    height: 3.954,
    transform: "translate(3.954) rotate(90)",
    fill: "#374d69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1644",
    "data-name": "Group 1644",
    transform: "translate(1460.048 223.647)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1242",
    "data-name": "Rectangle 1242",
    width: 95.119,
    height: 7.927,
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1243",
    "data-name": "Rectangle 1243",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1645",
    "data-name": "Group 1645",
    transform: "translate(876.123 223.647)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1244",
    "data-name": "Rectangle 1244",
    width: 95.119,
    height: 7.927,
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1245",
    "data-name": "Rectangle 1245",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1646",
    "data-name": "Group 1646",
    transform: "translate(612.968 223.647)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1246",
    "data-name": "Rectangle 1246",
    width: 95.119,
    height: 7.927,
    transform: "translate(0)",
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1247",
    "data-name": "Rectangle 1247",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1647",
    "data-name": "Group 1647",
    transform: "translate(343.464 223.647)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1248",
    "data-name": "Rectangle 1248",
    width: 95.119,
    height: 7.927,
    transform: "translate(0)",
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1249",
    "data-name": "Rectangle 1249",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1648",
    "data-name": "Group 1648",
    transform: "translate(1172.709 162.215)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1250",
    "data-name": "Rectangle 1250",
    width: 95.119,
    height: 7.927,
    fill: "#334259"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1251",
    "data-name": "Rectangle 1251",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#47587a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1649",
    "data-name": "Group 1649",
    transform: "translate(1716.671 223.647)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1252",
    "data-name": "Rectangle 1252",
    width: 95.119,
    height: 7.927,
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1253",
    "data-name": "Rectangle 1253",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1653",
    "data-name": "Group 1653",
    transform: "translate(1640.199 509.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1254",
    "data-name": "Rectangle 1254",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 67.04,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 65.04,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1255",
    "data-name": "Rectangle 1255",
    transform: "translate(0 67.04)",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 77.691,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 75.691,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1256",
    "data-name": "Rectangle 1256",
    transform: "translate(0 144.73)",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 107.65,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 105.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1650",
    "data-name": "Group 1650",
    transform: "translate(87.249 12.601)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1257",
    "data-name": "Rectangle 1257",
    width: 95.119,
    height: 7.927,
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1258",
    "data-name": "Rectangle 1258",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1651",
    "data-name": "Group 1651",
    transform: "translate(87.249 77.995)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1259",
    "data-name": "Rectangle 1259",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1260",
    "data-name": "Rectangle 1260",
    width: 95.119,
    height: 7.927,
    fill: "#4d5e82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1652",
    "data-name": "Group 1652",
    transform: "translate(87.249 158.252)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1261",
    "data-name": "Rectangle 1261",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1262",
    "data-name": "Rectangle 1262",
    width: 95.119,
    height: 7.927,
    fill: "#4d5e82"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1263",
    "data-name": "Rectangle 1263",
    width: 148.623,
    height: 24.771,
    transform: "translate(1138.141 211.261)",
    fill: "#222e44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1264",
    "data-name": "Rectangle 1264",
    width: 19.681,
    height: 24.771,
    transform: "translate(1344.47 211.261)",
    fill: "#4d3c48"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1265",
    "data-name": "Rectangle 1265",
    width: 19.681,
    height: 24.771,
    transform: "translate(1318.709 211.261)",
    fill: "#3c4e6b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1266",
    "data-name": "Rectangle 1266",
    width: 19.681,
    height: 24.771,
    transform: "translate(1109.315 211.261)",
    fill: "#3c4e6b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658",
    transform: "translate(1053.529 447.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1267",
    "data-name": "Rectangle 1267",
    transform: "translate(0 43.353)",
    fill: "#4d5e82",
    stroke: "#47587a",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323.337,
    height: 206.472,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 321.337,
    height: 204.472,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1268",
    "data-name": "Rectangle 1268",
    transform: "translate(0 249.825)",
    fill: "#4d5e82",
    stroke: "#47587a",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323.337,
    height: 64.964,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 321.337,
    height: 62.964,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M1130.608,402.034H807.271l36.254-43.353h250.828Z",
    transform: "translate(-807.271 -358.681)",
    fill: "#28364c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1269",
    "data-name": "Rectangle 1269",
    width: 274.788,
    height: 116.257,
    transform: "translate(25.03 105.826)",
    fill: "#222e44"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1655",
    "data-name": "Group 1655",
    transform: "translate(25.406 60.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1654",
    "data-name": "Group 1654",
    transform: "translate(38.282)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_469",
    "data-name": "Ellipse 469",
    cx: 11.589,
    cy: 11.589,
    rx: 11.589,
    ry: 11.589,
    fill: "#4d3c48"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_470",
    "data-name": "Ellipse 470",
    cx: 11.589,
    cy: 11.589,
    rx: 11.589,
    ry: 11.589,
    transform: "translate(37.982)",
    fill: "#4d3c48"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_471",
    "data-name": "Ellipse 471",
    cx: 11.589,
    cy: 11.589,
    rx: 11.589,
    ry: 11.589,
    transform: "translate(75.963)",
    fill: "#4d3c48"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_472",
    "data-name": "Ellipse 472",
    cx: 11.589,
    cy: 11.589,
    rx: 11.589,
    ry: 11.589,
    transform: "translate(113.945)",
    fill: "#4d3c48"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_473",
    "data-name": "Ellipse 473",
    cx: 11.589,
    cy: 11.589,
    rx: 11.589,
    ry: 11.589,
    transform: "translate(151.926)",
    fill: "#4d3c48"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1270",
    "data-name": "Rectangle 1270",
    width: 44.165,
    height: 20.58,
    transform: "translate(229.871 2.238)",
    fill: "#222e44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1271",
    "data-name": "Rectangle 1271",
    width: 21.365,
    height: 20.58,
    transform: "translate(0 2.238)",
    fill: "#222e44"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_474",
    "data-name": "Ellipse 474",
    cx: 6.258,
    cy: 6.258,
    rx: 6.258,
    ry: 6.258,
    transform: "translate(43.613 5.331)",
    fill: "#252932"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_475",
    "data-name": "Ellipse 475",
    cx: 6.258,
    cy: 6.258,
    rx: 6.258,
    ry: 6.258,
    transform: "translate(81.595 5.331)",
    fill: "#252932"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_476",
    "data-name": "Ellipse 476",
    cx: 6.258,
    cy: 6.258,
    rx: 6.258,
    ry: 6.258,
    transform: "translate(119.576 5.331)",
    fill: "#252932"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_477",
    "data-name": "Ellipse 477",
    cx: 6.258,
    cy: 6.258,
    rx: 6.258,
    ry: 6.258,
    transform: "translate(157.558 5.331)",
    fill: "#252932"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_478",
    "data-name": "Ellipse 478",
    cx: 6.258,
    cy: 6.258,
    rx: 6.258,
    ry: 6.258,
    transform: "translate(195.539 5.331)",
    fill: "#252932"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1656",
    "data-name": "Group 1656",
    transform: "translate(32.979 21.151)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_479",
    "data-name": "Ellipse 479",
    cx: 58.459,
    cy: 7.75,
    rx: 58.459,
    ry: 7.75,
    fill: "#192435"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_480",
    "data-name": "Ellipse 480",
    cx: 58.459,
    cy: 7.75,
    rx: 58.459,
    ry: 7.75,
    transform: "translate(138.715)",
    fill: "#192435"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1657",
    "data-name": "Group 1657",
    transform: "translate(50.16 4.45)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_481",
    "data-name": "Ellipse 481",
    cx: 49.228,
    cy: 6.526,
    rx: 49.228,
    ry: 6.526,
    fill: "#192435"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_482",
    "data-name": "Ellipse 482",
    cx: 49.228,
    cy: 6.526,
    rx: 49.228,
    ry: 6.526,
    transform: "translate(116.813)",
    fill: "#192435"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1660",
    "data-name": "Group 1660",
    transform: "translate(1623.874 290.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_483",
    "data-name": "Ellipse 483",
    cx: 14.862,
    cy: 14.862,
    rx: 14.862,
    ry: 14.862,
    fill: "#253249"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_484",
    "data-name": "Ellipse 484",
    cx: 14.862,
    cy: 14.862,
    rx: 14.862,
    ry: 14.862,
    transform: "translate(209.687)",
    fill: "#253249"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1272",
    "data-name": "Rectangle 1272",
    width: 217.641,
    height: 9.908,
    transform: "translate(10.559 9.908)",
    fill: "#253249"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662",
    transform: "translate(312.052 290.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1661",
    "data-name": "Group 1661",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_485",
    "data-name": "Ellipse 485",
    cx: 14.862,
    cy: 14.862,
    rx: 14.862,
    ry: 14.862,
    fill: "#253249"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_486",
    "data-name": "Ellipse 486",
    cx: 14.862,
    cy: 14.862,
    rx: 14.862,
    ry: 14.862,
    transform: "translate(209.687)",
    fill: "#253249"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1273",
    "data-name": "Rectangle 1273",
    width: 217.641,
    height: 9.908,
    transform: "translate(10.559 9.908)",
    fill: "#253249"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1666",
    "data-name": "Group 1666",
    transform: "translate(790.196 509.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1274",
    "data-name": "Rectangle 1274",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 67.04,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 65.04,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1275",
    "data-name": "Rectangle 1275",
    transform: "translate(0 67.04)",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 77.691,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 75.691,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1276",
    "data-name": "Rectangle 1276",
    transform: "translate(0 144.73)",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 107.65,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 261.333,
    height: 105.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1663",
    "data-name": "Group 1663",
    transform: "translate(87.249 12.601)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1277",
    "data-name": "Rectangle 1277",
    width: 95.119,
    height: 7.927,
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1278",
    "data-name": "Rectangle 1278",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664",
    transform: "translate(87.249 77.995)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1279",
    "data-name": "Rectangle 1279",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1280",
    "data-name": "Rectangle 1280",
    width: 95.119,
    height: 7.927,
    fill: "#4d5e82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1665",
    "data-name": "Group 1665",
    transform: "translate(87.249 158.252)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1281",
    "data-name": "Rectangle 1281",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1282",
    "data-name": "Rectangle 1282",
    width: 95.119,
    height: 7.927,
    fill: "#4d5e82"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1668",
    "data-name": "Group 1668",
    transform: "translate(526.862 509.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1283",
    "data-name": "Rectangle 1283",
    transform: "translate(0)",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 252.941,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 260.333,
    height: 249.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1667",
    "data-name": "Group 1667",
    transform: "translate(83.182 12.601)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1284",
    "data-name": "Rectangle 1284",
    width: 95.119,
    height: 7.927,
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1285",
    "data-name": "Rectangle 1285",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1670",
    "data-name": "Group 1670",
    transform: "translate(263.529 509.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1286",
    "data-name": "Rectangle 1286",
    transform: "translate(0)",
    fill: "#173f5e",
    stroke: "#173a58",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.333,
    height: 252.941,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 260.333,
    height: 249.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1669",
    "data-name": "Group 1669",
    transform: "translate(83.182 12.601)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1287",
    "data-name": "Rectangle 1287",
    width: 95.119,
    height: 7.927,
    fill: "#4d5e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1288",
    "data-name": "Rectangle 1288",
    width: 95.119,
    height: 3.954,
    transform: "translate(0 7.927)",
    fill: "#173a58"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1289",
    "data-name": "Rectangle 1289",
    width: 274.788,
    height: 26.422,
    transform: "translate(1078.558 553.261)",
    fill: "#192435"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1290",
    "data-name": "Rectangle 1290",
    transform: "translate(1078.558 540.05)",
    fill: "#4d5e82",
    stroke: "#47587a",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274.788,
    height: 13.211,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 272.788,
    height: 11.211,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1291",
    "data-name": "Rectangle 1291",
    width: 194.201,
    height: 180.33,
    transform: "translate(561.372 559.206)",
    fill: "#244969"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1292",
    "data-name": "Rectangle 1292",
    width: 194.201,
    height: 180.33,
    transform: "translate(1416.122 559.206)",
    fill: "#244969"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1293",
    "data-name": "Rectangle 1293",
    width: 194.201,
    height: 180.33,
    transform: "translate(1416.122 12.271)",
    fill: "#244969"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1294",
    "data-name": "Rectangle 1294",
    width: 194.201,
    height: 180.33,
    transform: "translate(1675.057 12.271)",
    fill: "#244969"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1295",
    "data-name": "Rectangle 1295",
    width: 194.201,
    height: 180.33,
    transform: "translate(825.591 12.271)",
    fill: "#244969"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1296",
    "data-name": "Rectangle 1296",
    width: 194.201,
    height: 180.33,
    transform: "translate(565.335 12.271)",
    fill: "#244969"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1297",
    "data-name": "Rectangle 1297",
    width: 194.201,
    height: 180.33,
    transform: "translate(298.473 12.271)",
    fill: "#244969"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1298",
    "data-name": "Rectangle 1298",
    width: 194.201,
    height: 180.33,
    transform: "translate(295.831 559.206)",
    fill: "#244969"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1299",
    "data-name": "Rectangle 1299",
    width: 2167.062,
    height: 10.338,
    transform: "translate(0 762.225)",
    fill: "#192435"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1671",
    "data-name": "Group 1671",
    transform: "translate(1960.084 173.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M1713.826,134.4h40.649l1.824-41.17H1715.65Z",
    transform: "translate(-1713.826 -85.021)",
    fill: "#324963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M1756.3,93.229H1715.65s-1.042,29.965,5.472,44.557h44.557C1757.6,122.934,1756.3,93.229,1756.3,93.229Z",
    transform: "translate(-1713.826 -85.021)",
    fill: "#4c593d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_487",
    "data-name": "Ellipse 487",
    cx: 7.426,
    cy: 7.426,
    rx: 7.426,
    ry: 7.426,
    transform: "translate(14.722)",
    fill: "#422c31"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_488",
    "data-name": "Ellipse 488",
    cx: 7.426,
    cy: 7.426,
    rx: 7.426,
    ry: 7.426,
    transform: "translate(17.458)",
    fill: "#4d3539"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1672",
    "data-name": "Group 1672",
    transform: "translate(2047.702 195.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M1802.45,160.434l40.208-4.237-.565-38.16h-40.649Z",
    transform: "translate(-1801.445 -106.819)",
    fill: "#324963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M1841.826,113.379l-40.381,4.658s2.4,29.887,10.542,43.637l44.264-5.107C1846.524,142.738,1841.826,113.379,1841.826,113.379Z",
    transform: "translate(-1801.445 -106.819)",
    fill: "#4c593d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_489",
    "data-name": "Ellipse 489",
    cx: 7.426,
    cy: 7.426,
    rx: 7.426,
    ry: 7.426,
    transform: "translate(15.287)",
    fill: "#422c31"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_490",
    "data-name": "Ellipse 490",
    cx: 7.426,
    cy: 7.426,
    rx: 7.426,
    ry: 7.426,
    transform: "translate(18.023)",
    fill: "#4d3539"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1674",
    "data-name": "Group 1674",
    transform: "translate(1980.987 319.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M1735.734,282.856l40.208-4.237-.565-38.16h-40.649Z",
    transform: "translate(-1734.729 -231.002)",
    fill: "#324963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M1775.11,235.8l-40.381,4.659s2.4,29.887,10.542,43.636l44.264-5.106C1779.809,265.16,1775.11,235.8,1775.11,235.8Z",
    transform: "translate(-1734.729 -231.002)",
    fill: "#4c593d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1673",
    "data-name": "Group 1673",
    transform: "translate(10.003)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_491",
    "data-name": "Ellipse 491",
    cx: 7.426,
    cy: 7.426,
    rx: 7.426,
    ry: 7.426,
    fill: "#422c31"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_492",
    "data-name": "Ellipse 492",
    cx: 7.426,
    cy: 7.426,
    rx: 7.426,
    ry: 7.426,
    transform: "translate(2.736)",
    fill: "#4d3539"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1300",
    "data-name": "Rectangle 1300",
    width: 250.828,
    height: 25.985,
    transform: "translate(1089.783 421.45)",
    fill: "#465970"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "kitchen_light",
    transform: "translate(642.673 252.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1701",
    "data-name": "Group 1701"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1301",
    "data-name": "Rectangle 1301",
    width: 1126.636,
    height: 237.847,
    fill: "url(#linear-gradient-kitchen-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1695",
    "data-name": "Group 1695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1676",
    "data-name": "Group 1676",
    transform: "translate(783.747)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1302",
    "data-name": "Rectangle 1302",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1303",
    "data-name": "Rectangle 1303",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1304",
    "data-name": "Rectangle 1304",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1305",
    "data-name": "Rectangle 1305",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1306",
    "data-name": "Rectangle 1306",
    width: 48.984,
    height: 48.623,
    transform: "translate(734.763 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1307",
    "data-name": "Rectangle 1307",
    width: 48.984,
    height: 48.623,
    transform: "translate(734.763 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1308",
    "data-name": "Rectangle 1308",
    width: 48.984,
    height: 48.623,
    transform: "translate(734.763)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1677",
    "data-name": "Group 1677",
    transform: "translate(685.779)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1309",
    "data-name": "Rectangle 1309",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1310",
    "data-name": "Rectangle 1310",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1311",
    "data-name": "Rectangle 1311",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1312",
    "data-name": "Rectangle 1312",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1678",
    "data-name": "Group 1678",
    transform: "translate(930.699)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1313",
    "data-name": "Rectangle 1313",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1314",
    "data-name": "Rectangle 1314",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1315",
    "data-name": "Rectangle 1315",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1316",
    "data-name": "Rectangle 1316",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1317",
    "data-name": "Rectangle 1317",
    width: 48.984,
    height: 48.623,
    transform: "translate(881.715 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1318",
    "data-name": "Rectangle 1318",
    width: 48.984,
    height: 48.623,
    transform: "translate(881.715 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1319",
    "data-name": "Rectangle 1319",
    width: 48.984,
    height: 48.623,
    transform: "translate(881.715)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1679",
    "data-name": "Group 1679",
    transform: "translate(832.731)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1320",
    "data-name": "Rectangle 1320",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1321",
    "data-name": "Rectangle 1321",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1322",
    "data-name": "Rectangle 1322",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1323",
    "data-name": "Rectangle 1323",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1680",
    "data-name": "Group 1680",
    transform: "translate(636.794)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1324",
    "data-name": "Rectangle 1324",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1325",
    "data-name": "Rectangle 1325",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1326",
    "data-name": "Rectangle 1326",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1327",
    "data-name": "Rectangle 1327",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1681",
    "data-name": "Group 1681",
    transform: "translate(587.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1328",
    "data-name": "Rectangle 1328",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1329",
    "data-name": "Rectangle 1329",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1330",
    "data-name": "Rectangle 1330",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1331",
    "data-name": "Rectangle 1331",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1682",
    "data-name": "Group 1682",
    transform: "translate(538.826)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1332",
    "data-name": "Rectangle 1332",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1333",
    "data-name": "Rectangle 1333",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1334",
    "data-name": "Rectangle 1334",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1335",
    "data-name": "Rectangle 1335",
    width: 48.984,
    height: 48.623,
    transform: "translate(0)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1683",
    "data-name": "Group 1683",
    transform: "translate(489.842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1336",
    "data-name": "Rectangle 1336",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1337",
    "data-name": "Rectangle 1337",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1338",
    "data-name": "Rectangle 1338",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1339",
    "data-name": "Rectangle 1339",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1684",
    "data-name": "Group 1684",
    transform: "translate(440.858)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1340",
    "data-name": "Rectangle 1340",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1341",
    "data-name": "Rectangle 1341",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1342",
    "data-name": "Rectangle 1342",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1343",
    "data-name": "Rectangle 1343",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1685",
    "data-name": "Group 1685",
    transform: "translate(391.874)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1344",
    "data-name": "Rectangle 1344",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1345",
    "data-name": "Rectangle 1345",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1346",
    "data-name": "Rectangle 1346",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1347",
    "data-name": "Rectangle 1347",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1686",
    "data-name": "Group 1686",
    transform: "translate(342.889)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1348",
    "data-name": "Rectangle 1348",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1349",
    "data-name": "Rectangle 1349",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1350",
    "data-name": "Rectangle 1350",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1351",
    "data-name": "Rectangle 1351",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1687",
    "data-name": "Group 1687",
    transform: "translate(293.905)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1352",
    "data-name": "Rectangle 1352",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1353",
    "data-name": "Rectangle 1353",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1354",
    "data-name": "Rectangle 1354",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1355",
    "data-name": "Rectangle 1355",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1688",
    "data-name": "Group 1688",
    transform: "translate(244.921)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1356",
    "data-name": "Rectangle 1356",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1357",
    "data-name": "Rectangle 1357",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1358",
    "data-name": "Rectangle 1358",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1359",
    "data-name": "Rectangle 1359",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1689",
    "data-name": "Group 1689",
    transform: "translate(195.937)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1360",
    "data-name": "Rectangle 1360",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1361",
    "data-name": "Rectangle 1361",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1362",
    "data-name": "Rectangle 1362",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1363",
    "data-name": "Rectangle 1363",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1690",
    "data-name": "Group 1690",
    transform: "translate(146.953)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1364",
    "data-name": "Rectangle 1364",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1365",
    "data-name": "Rectangle 1365",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1366",
    "data-name": "Rectangle 1366",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1367",
    "data-name": "Rectangle 1367",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1691",
    "data-name": "Group 1691",
    transform: "translate(1077.652)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1368",
    "data-name": "Rectangle 1368",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1369",
    "data-name": "Rectangle 1369",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1370",
    "data-name": "Rectangle 1370",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1371",
    "data-name": "Rectangle 1371",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1372",
    "data-name": "Rectangle 1372",
    width: 48.984,
    height: 48.623,
    transform: "translate(1028.668 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1373",
    "data-name": "Rectangle 1373",
    width: 48.984,
    height: 48.623,
    transform: "translate(1028.668 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1374",
    "data-name": "Rectangle 1374",
    width: 48.984,
    height: 48.623,
    transform: "translate(1028.668)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1692",
    "data-name": "Group 1692",
    transform: "translate(979.684)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1375",
    "data-name": "Rectangle 1375",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1376",
    "data-name": "Rectangle 1376",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1377",
    "data-name": "Rectangle 1377",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1378",
    "data-name": "Rectangle 1378",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1693",
    "data-name": "Group 1693",
    transform: "translate(97.968)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1379",
    "data-name": "Rectangle 1379",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1380",
    "data-name": "Rectangle 1380",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1381",
    "data-name": "Rectangle 1381",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1382",
    "data-name": "Rectangle 1382",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1383",
    "data-name": "Rectangle 1383",
    width: 48.984,
    height: 48.623,
    transform: "translate(48.984 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1384",
    "data-name": "Rectangle 1384",
    width: 48.984,
    height: 48.623,
    transform: "translate(48.984 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1385",
    "data-name": "Rectangle 1385",
    width: 48.984,
    height: 48.623,
    transform: "translate(48.984)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1694",
    "data-name": "Group 1694"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1386",
    "data-name": "Rectangle 1386",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 145.87)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1387",
    "data-name": "Rectangle 1387",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 97.247)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1388",
    "data-name": "Rectangle 1388",
    width: 48.984,
    height: 48.623,
    transform: "translate(0 48.623)",
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1389",
    "data-name": "Rectangle 1389",
    width: 48.984,
    height: 48.623,
    fill: "none",
    stroke: "#445466",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1698",
    "data-name": "Group 1698",
    transform: "translate(410.856 168.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M1130.608,402.034H807.271l36.254-43.353h250.828Z",
    transform: "translate(-807.271 -332.696)",
    fill: "#474f57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1696",
    "data-name": "Group 1696",
    transform: "translate(32.979 47.136)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_493",
    "data-name": "Ellipse 493",
    cx: 58.459,
    cy: 7.75,
    rx: 58.459,
    ry: 7.75,
    fill: "#1c2932"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_494",
    "data-name": "Ellipse 494",
    cx: 58.459,
    cy: 7.75,
    rx: 58.459,
    ry: 7.75,
    transform: "translate(138.715)",
    fill: "#1c2932"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1697",
    "data-name": "Group 1697",
    transform: "translate(50.16 30.434)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_495",
    "data-name": "Ellipse 495",
    cx: 49.228,
    cy: 6.526,
    rx: 49.228,
    ry: 6.526,
    fill: "#1c2932"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_496",
    "data-name": "Ellipse 496",
    cx: 49.228,
    cy: 6.526,
    rx: 49.228,
    ry: 6.526,
    transform: "translate(116.813)",
    fill: "#1c2932"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1390",
    "data-name": "Rectangle 1390",
    width: 250.828,
    height: 25.985,
    transform: "translate(36.254)",
    fill: "#575f66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1700",
    "data-name": "Group 1700",
    transform: "translate(981.201 37.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1699",
    "data-name": "Group 1699"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_497",
    "data-name": "Ellipse 497",
    cx: 14.862,
    cy: 14.862,
    rx: 14.862,
    ry: 14.862,
    fill: "#253249"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_498",
    "data-name": "Ellipse 498",
    cx: 14.862,
    cy: 14.862,
    rx: 14.862,
    ry: 14.862,
    transform: "translate(209.687)",
    fill: "#253249"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1391",
    "data-name": "Rectangle 1391",
    width: 217.641,
    height: 9.908,
    transform: "translate(10.559 9.908)",
    fill: "#253249"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1716",
    "data-name": "Group 1716",
    transform: "translate(-394.155 -162.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bigpot"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1703",
    "data-name": "Group 1703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1392",
    "data-name": "Rectangle 1392",
    d: "M0,0H25.023A4.117,4.117,0,0,1,29.14,4.117v0a4.117,4.117,0,0,1-4.117,4.117H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(1085.988 325.34) rotate(-19.432)",
    fill: "#575f66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1393",
    "data-name": "Rectangle 1393",
    d: "M0,0H25.023A4.117,4.117,0,0,1,29.14,4.117v0a4.117,4.117,0,0,1-4.117,4.117H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(984.187 333.105) rotate(-160.568)",
    fill: "#6f767a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1704",
    "data-name": "Group 1704"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_499",
    "data-name": "Ellipse 499",
    cx: 51.503,
    cy: 7.084,
    rx: 51.503,
    ry: 7.084,
    transform: "translate(984.954 377.799)",
    fill: "#575f66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1394",
    "data-name": "Rectangle 1394",
    width: 103.007,
    height: 26.642,
    transform: "translate(984.954 358.241)",
    fill: "#575f66"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M1084.29,383.186c-11.451,2.39-24,3.491-47.561,3.491s-36.33-1.1-48.1-3.491C982.874,382.018,978,378.428,978,372.559V316.47h116.917v56.089C1094.916,378.428,1090.035,381.987,1084.29,383.186Z",
    fill: "#6f767a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1706",
    "data-name": "Group 1706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1705",
    "data-name": "Group 1705",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1395",
    "data-name": "Rectangle 1395",
    width: 55.486,
    height: 116.917,
    transform: "translate(1011.399 291.337)",
    fill: "#83898c"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_500",
    "data-name": "Ellipse 500",
    cx: 58.459,
    cy: 7.75,
    rx: 58.459,
    ry: 7.75,
    transform: "translate(977.999 308.72)",
    fill: "#98a0a5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_501",
    "data-name": "Ellipse 501",
    cx: 53.854,
    cy: 5.996,
    rx: 53.854,
    ry: 5.996,
    transform: "translate(982.604 310.403)",
    fill: "#3d4144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M989.826,319.4c9.313,1.791,26.7,3,46.632,3s37.318-1.207,46.631-3c-9.313-1.792-26.7-3-46.631-3S999.139,317.605,989.826,319.4Z",
    fill: "#49748c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "smallpot"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1711",
    "data-name": "Group 1711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1707",
    "data-name": "Group 1707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1396",
    "data-name": "Rectangle 1396",
    d: "M0,0H20.16a3.317,3.317,0,0,1,3.317,3.317v0A3.317,3.317,0,0,1,20.16,6.634H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(945.616 307.718) rotate(-19.432)",
    fill: "#575f66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1397",
    "data-name": "Rectangle 1397",
    d: "M0,0H20.16a3.317,3.317,0,0,1,3.317,3.317v0A3.317,3.317,0,0,1,20.16,6.634H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(863.597 313.974) rotate(-160.568)",
    fill: "#6f767a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1708",
    "data-name": "Group 1708"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_502",
    "data-name": "Ellipse 502",
    cx: 41.495,
    cy: 5.707,
    rx: 41.495,
    ry: 5.707,
    transform: "translate(864.215 361.985)",
    fill: "#575f66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1398",
    "data-name": "Rectangle 1398",
    width: 82.991,
    height: 21.465,
    transform: "translate(864.215 346.227)",
    fill: "#575f66"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M944.248,366.325c-9.226,1.926-19.338,2.813-38.319,2.813s-29.271-.887-38.756-2.813c-4.634-.94-8.562-3.833-8.562-8.561V300.572h94.2v57.192C952.809,362.492,948.876,365.359,944.248,366.325Z",
    fill: "#6f767a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1710",
    "data-name": "Group 1710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1709",
    "data-name": "Group 1709",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1399",
    "data-name": "Rectangle 1399",
    width: 44.704,
    height: 106.2,
    transform: "translate(885.521 280.323)",
    fill: "#83898c"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_503",
    "data-name": "Ellipse 503",
    cx: 47.099,
    cy: 6.244,
    rx: 47.099,
    ry: 6.244,
    transform: "translate(858.611 294.328)",
    fill: "#98a0a5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_504",
    "data-name": "Ellipse 504",
    cx: 43.389,
    cy: 4.831,
    rx: 43.389,
    ry: 4.831,
    transform: "translate(862.321 295.684)",
    fill: "#3d4144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M868.14,302.93c7.5,1.443,21.513,2.415,37.57,2.415s30.067-.972,37.57-2.415c-7.5-1.444-21.513-2.415-37.57-2.415S875.643,301.486,868.14,302.93Z",
    fill: "#49748c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1712",
    "data-name": "Group 1712"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_505",
    "data-name": "Ellipse 505",
    cx: 47.099,
    cy: 6.244,
    rx: 47.099,
    ry: 6.244,
    transform: "translate(858.324 293.297)",
    fill: "#6f767a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_506",
    "data-name": "Ellipse 506",
    cx: 47.099,
    cy: 6.244,
    rx: 47.099,
    ry: 6.244,
    transform: "translate(858.324 291.785)",
    fill: "#6f767a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1400",
    "data-name": "Rectangle 1400",
    width: 94.198,
    height: 1.512,
    transform: "translate(858.324 298.029)",
    fill: "#6f767a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M952.522,298.029c0,3.449-21.087,6.245-47.1,6.245s-47.1-2.8-47.1-6.245,21.087-11.5,47.1-11.5S952.522,294.581,952.522,298.029Z",
    fill: "#98a0a5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_507",
    "data-name": "Ellipse 507",
    cx: 6.949,
    cy: 0.774,
    rx: 6.949,
    ry: 0.774,
    transform: "translate(898.528 286.269)",
    fill: "#3d4144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M912.426,287.043h-13.9l-1.765-13.175h17.428Z",
    fill: "#3d4144"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_508",
    "data-name": "Ellipse 508",
    cx: 8.714,
    cy: 0.97,
    rx: 8.714,
    ry: 0.97,
    transform: "translate(896.763 272.898)",
    fill: "#515659"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pan"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M833.235,368.718l-84.182-23.079c-1.726-.473-2.139-7.814-.691-8.867l3.346,2.648a7.924,7.924,0,0,1,7.032-1.153l77.267,24.214Z",
    fill: "#6f767a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M833.235,363.636l-84.182-23.079a2.134,2.134,0,0,1-.691-3.785l4.4-2.434a7.93,7.93,0,0,1,7.032-1.153L836.007,357.4Z",
    fill: "#83898c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1713",
    "data-name": "Group 1713"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_509",
    "data-name": "Ellipse 509",
    cx: 54.028,
    cy: 7.431,
    rx: 54.028,
    ry: 7.431,
    transform: "translate(843.214 377.609)",
    fill: "#575f66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1401",
    "data-name": "Rectangle 1401",
    width: 108.057,
    height: 27.948,
    transform: "translate(843.214 357.092)",
    fill: "#575f66"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M947.419,385.5c-12.012,2.507-25.178,3.662-49.892,3.662s-38.111-1.155-50.462-3.662c-6.033-1.224-7.686-6.055-11.147-11.147-2.508-3.688-9.973-14.777-9.973-14.777H968.539s-7.082,10.64-9.972,14.777C955.041,379.4,953.446,384.245,947.419,385.5Z",
    fill: "#6f767a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1714",
    "data-name": "Group 1714",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1402",
    "data-name": "Rectangle 1402",
    width: 58.206,
    height: 78.587,
    transform: "translate(868.183 337.024)",
    fill: "#83898c"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_510",
    "data-name": "Ellipse 510",
    cx: 71.297,
    cy: 8.13,
    rx: 71.297,
    ry: 8.13,
    transform: "translate(825.945 351.448)",
    fill: "#98a0a5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_511",
    "data-name": "Ellipse 511",
    cx: 65.681,
    cy: 6.29,
    rx: 65.681,
    ry: 6.29,
    transform: "translate(831.561 353.214)",
    fill: "#3d4144"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.41fbfca30e9fe6631e9c7dc1e3a5b187.svg";
export { ForwardRef as ReactComponent };